// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Y6cdm","title":"Header_title__2zI2R","left":"Header_left__2YSTr","clinicName":"Header_clinicName__eaxmD"};